import React, { FC } from 'react';
import TextInput from '../TextInput';
import { SafeAreaView, TextInputProps } from 'react-native';
import styles from './styles';

type PasswordInputProps = {
  errorMessage?: string | boolean;
  placeholderLabel?: string;
  value: string;
  onBlur: Function;
  onChangeText: Function;
};

export type InputProps = PasswordInputProps & TextInputProps;

export const PasswordInput: FC<InputProps> = (props) => {
  const { errorMessage, onBlur, onChangeText, placeholderLabel, value } = props;
  const placeholder = placeholderLabel || 'Password';
  return (
    <SafeAreaView>
      <TextInput
        autoCapitalize="none"
        autoCompleteType="password"
        errorMessage={errorMessage}
        imageKey={'lock'}
        imageStyle={styles.imageStyle}
        keyboardType="default"
        label="Password"
        labelHidden
        onBlur={onBlur}
        onChangeText={onChangeText}
        value={value}
        placeholder={placeholder}
        secureTextEntry
        textContentType="password"
      />
    </SafeAreaView>
  );
};

export default PasswordInput;
